<template>
  <a class="flex-row" @click.stop="handleCopy">
    <span
      class="svn-url"
      :title="displayText"
    >{{ displayText }}</span>
    <a-icon
      type="copy"
      class="copy-icon"
    />
  </a>
</template>

<script>
export default {
  name: 'ReallinOaWebCopyText',
  props: {
    text: {
      type: [String, Number],
      default: ''
    },
    copyVal: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    displayText() {
      const val = this.text !== '' && this.text !== null && this.text !== undefined
        ? this.text
        : this.copyVal
      return val == null ? '' : String(val)
    },
    copyText() {
      const val = this.copyVal !== '' && this.copyVal !== null && this.copyVal !== undefined
        ? this.copyVal
        : this.text
      return val == null ? '' : String(val)
    }
  },
  methods: {
    handleCopy() {
      const val = this.copyText
      if (!val) {
        return
      }
      
      // 方法1: 使用 vue-clipboard2 插件
      if (this.$copyText) {
        this.$copyText(val)
          .then(() => {
            this.$message.success('内容已复制到剪切板！')
          })
          .catch(() => {
            this.fallbackCopy(val)
          })
        return
      }
      
      // 方法2: 使用现代 Clipboard API
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(val)
          .then(() => {
            this.$message.success('内容已复制到剪切板！')
          })
          .catch(() => {
            this.fallbackCopy(val)
          })
        return
      }
      
      // 方法3: 降级方案
      this.fallbackCopy(val)
    },
    
    fallbackCopy(text) {
      // 使用传统的 document.execCommand 方法
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.top = '0'
      textarea.style.left = '0'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('内容已复制到剪切板！')
        } else {
          this.$message.error('抱歉，复制失败！')
        }
      } catch (err) {
        console.error('复制失败:', err)
        this.$message.error('抱歉，复制失败！')
      } finally {
        document.body.removeChild(textarea)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.flex-row {
  display: flex;
  align-items: center;

  .svn-url {
    display: inline-block;
    text-align: left;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .copy-icon {
    margin-left: 4px;
    cursor: pointer;
    color: #1890ff;
  }
}
</style>
